<div class="modal" *ngIf="roleToDetach && group">
    <div class="header">
        <h1 class="title" translate [translateParams]="{ name: roleToDetach.translatedName, group: group.name }">
            PREMIUM_TEAM_MODAL_DETACH_ROLE_FROM_GROUP_QUESTION</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(detachRoleFromGroupPending$ | async); else notProcessing">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #notProcessing>
            <div class="section">
                <div class="description" translate>PREMIUM_TEAM_MEMBER_MODAL_DETACH_ROLE_FROM_GROUP_QUESTION_CONFIRMATION</div>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()" [disabled]="(detachRoleFromGroupPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL</button>
        <button class="btn-new red" (click)="detachRoleFromGroup()" [disabled]="(detachRoleFromGroupPending$ | async)"
            translate>PREMIUM_TEAM_MEMBER_MODAL_MODAL_DETACH_ROLE_FROM_GROUP_BUTTON_LABEL_DETACH_ROLE</button>
    </div>
</div>